import React from 'react';
import mixpanel from 'mixpanel-browser';

import scottGraham from './Images/scott-graham-unsplash.jpg';

import { howCashCleverWorksObj } from '../../constants/Pages/Landing';

import './CashCleverWorks.css';

export const CashCleverWorks = ({ userId }) => {
  const { title, HowCashCleverWorksSteps } = howCashCleverWorksObj;
  return (
    <>
      <h2 className="cashclever-works-header">{title}</h2>
      <div className="cashclever-works-content-wrapper">
        <div className="cashclever-works-steps-wrapper">
          {Object.keys(HowCashCleverWorksSteps).map((step) => (
            <div
              className="cashclever-works-steps-content-wrapper"
              key={step}
              onClick={() =>
                mixpanel.track('CashClever Works', {
                  distinct_id: userId,
                  step,
                  title: HowCashCleverWorksSteps[step].title,
                  path: '/',
                })
              }
            >
              <div className="step-content-wrapper">
                <div className="step__number">{step}</div>
                <div className="step_number_info_wrapper">
                  <h5 className="steps_heading">{HowCashCleverWorksSteps[step].title}</h5>
                  <div className="steps_paragraph">{HowCashCleverWorksSteps[step].description}</div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="cashclever-works-img-section-wrapper">
          <div className="cashclever-works-placeholder-wrapper">-</div>
          <div className="cashclever-tyler-franta-img-wrapper">
            <img src={scottGraham} alt="how we work image" className="scott-graham-img" />
          </div>
        </div>
      </div>
    </>
  );
};
